import * as React from 'react'
import { useTranslation } from 'react-i18next'

import InDevelopmentIcon from '@wwt/shared/assets/icons/outline/in-development.svg'

import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip'

export interface UnderDevelopmentProps {
	children?: React.ReactNode
	asChild?: boolean
}

const UnderDevelopment = ({
	children,
	asChild = false
}: UnderDevelopmentProps) => {
	const { t } = useTranslation('tooltips')

	const triggerRef = React.useRef<HTMLButtonElement>(null)

	/**
	 * FIXME: Rewrite this component to tooltip + popover(on mobiles)
	 * Right now we have an problem when tooltips not working inside of
	 * DialogFooter on mobiles and based on:
	 * - https://github.com/radix-ui/primitives/issues/955#issuecomment-960610209
	 * - https://github.com/radix-ui/primitives/issues/2589
	 * - https://www.radix-ui.com/primitives/docs/components/tooltip first sentence
	 * it should not work on mobiles at all!
	 * So we should use popovers instead for all tooltips
	 *
	 * Jira - FE-3758
	 */
	return (
		<Tooltip delayDuration={0}>
			<TooltipTrigger
				ref={triggerRef}
				asChild={asChild}
				onClick={event => event.preventDefault()}
			>
				{children}
			</TooltipTrigger>
			<TooltipContent
				// TODO: fix z-index after refactoring entire app
				className="z-1800 flex w-fit items-center gap-4 py-3"
				side="bottom"
				onPointerDownOutside={event => {
					if (event.target === triggerRef.current) event.preventDefault()
				}}
			>
				<InDevelopmentIcon /> {t('featureIsNotImplementedYet')}
			</TooltipContent>
		</Tooltip>
	)
}

export { UnderDevelopment }
